import { render, staticRenderFns } from "./OtpConfirmation.vue?vue&type=template&id=8c83c9b6"
import script from "./OtpConfirmation.vue?vue&type=script&lang=js"
export * from "./OtpConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OtpConfirmation.vue?vue&type=style&index=0&id=8c83c9b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports